import { render, staticRenderFns } from "./adduser.vue?vue&type=template&id=0b052986"
import script from "./adduser.vue?vue&type=script&lang=js"
export * from "./adduser.vue?vue&type=script&lang=js"
import style0 from "./adduser.vue?vue&type=style&index=0&id=0b052986&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports